import { render, staticRenderFns } from "./LoanProduct.vue?vue&type=template&id=16e58410&"
import script from "./LoanProduct.vue?vue&type=script&lang=js&"
export * from "./LoanProduct.vue?vue&type=script&lang=js&"
import style0 from "./LoanProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports